import { createStore, compose, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import reducers from './modules/rootReducer';
import rootSaga from './modules/rootSaga';

import api from '../api/api';
import { signout } from './modules/auth/actions';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  persistedReducer,
  compose(
    applyMiddleware(sagaMiddleware),
    ...(window.__REDUX_DEVTOOLS_EXTENSION__ ? [window.__REDUX_DEVTOOLS_EXTENSION__()] : [])
  )
);
const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

// TODO i think that it should be at the api.js file, but it gets a
// "circular ref" lint error
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      const { dispatch } = store;
      dispatch(signout());
    }
    return Promise.reject(error);
  }
);

export { store, persistor };
